"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _Button = _interopRequireDefault(require("@mui/material/Button"));
var _ButtonBase = _interopRequireDefault(require("@mui/material/ButtonBase"));
var _constantVariants = require("./constantVariants");
var _styles = require("./styles");
const _excluded = ["color", "variant"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
const SNETButton = _ref => {
  let {
      color,
      variant
    } = _ref,
    rest = _objectWithoutProperties(_ref, _excluded);
  const styleKey = () => {
    return "".concat(color, "-").concat(variant !== null && variant !== void 0 ? variant : "");
  };
  const buttonStyles = () => {
    return _constantVariants.buttonStyleVariants[styleKey()];
  };
  const classes = (0, _styles.useStyles)(buttonStyles());
  if (_constantVariants.muiButtonColors[color]) {
    return /*#__PURE__*/_react.default.createElement(_Button.default, _extends({
      className: classes.root,
      color: _constantVariants.muiButtonColors[color],
      variant: variant
    }, rest));
  }
  return /*#__PURE__*/_react.default.createElement(_ButtonBase.default, _extends({
    className: classes.root,
    color: color,
    variant: variant
  }, rest));
};
var _default = exports.default = SNETButton;